import { render, staticRenderFns } from "./survey2.vue?vue&type=template&id=239edc83&scoped=true&"
import script from "./survey2.vue?vue&type=script&lang=js&"
export * from "./survey2.vue?vue&type=script&lang=js&"
import style0 from "./survey2.vue?vue&type=style&index=0&id=239edc83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239edc83",
  null
  
)

export default component.exports